import type { TFunction } from 'i18next'
import type { Complaint } from '~/gql/complaints/complaints'
import { COMPLAINT_CATEGORY_KEYS, COMPLAINT_ORIGIN_KEYS, COMPLAINT_STATUS_KEYS } from './complaint-labels'

/**
 * Le registre en CSV (#325), pour l'auditeur : une ligne par entrée, avec les
 * dates qui mesurent le traitement (reçue, répondue, résolue).
 */
export function complaintsCsv(
  complaints: readonly Complaint[],
  t: TFunction,
  formatDate: (value: unknown) => string,
): { headers: string[], rows: string[][] } {
  const date = (value: unknown) => (value ? formatDate(value) : '')
  return {
    headers: [
      t('complaints.column.receivedAt'),
      t('complaints.column.category'),
      t('complaints.column.status'),
      t('complaints.column.origin'),
      t('complaints.column.author'),
      t('complaints.column.subject'),
      t('complaints.column.message'),
      t('complaints.column.response'),
      t('complaints.column.respondedAt'),
      t('complaints.column.resolvedAt'),
    ],
    rows: complaints.map(c => [
      date(c.createdAt),
      t(COMPLAINT_CATEGORY_KEYS[c.category]),
      t(COMPLAINT_STATUS_KEYS[c.status]),
      t(COMPLAINT_ORIGIN_KEYS[c.origin]),
      [c.authorName, c.authorEmail].filter(Boolean).join(' — '),
      c.subject,
      c.message,
      c.response ?? '',
      date(c.respondedAt),
      date(c.resolvedAt),
    ]),
  }
}
